<!-- Top Nav -->
<div
  class="navbar flex h-16 w-screen justify-between border-b border-base-300 bg-base-200 print:hidden"
>
  <div class="relative h-full">
    <a
      class="h-full px-2 text-3xl font-medium normal-case"
      [routerLink]="['/']"
    >
      <img
        class="inline-block h-full"
        src="/assets/accuzip-logo-184x168-icon-only.png"
      />
      <!-- <span class="text-primary">Accu</span
      ><span class="text-secondary">ZIP</span> -->
    </a>
  </div>
  <div>
    <div>
      @if (viewService.currentView === 'user') {
        <div class="indicator mr-4">
          @if (cartItemCount > 0) {
            <span class="badge indicator-item badge-primary top-1">
              {{ cartItemCount }}
            </span>
          }

          <div class="mt-2">
            <a routerLink="/cart">
              <app-cart-icon
                class="inline-block h-8 w-8 cursor-pointer text-current"
              ></app-cart-icon>
            </a>
          </div>
        </div>
      }
    </div>
    <details
      #mobileNavMenu
      class="dropdown dropdown-end dropdown-bottom [position:unset]"
      (click)="toggleMobileNav($event)"
    >
      <summary class="btn btn-ghost no-animation">
        <div class="flex items-center">
          <!-- <label tabindex="0" class="btn avatar btn-circle btn-ghost">
            <div class="w-10 rounded-full">
              @if (userImageURL) {
                <img src="{{ userImageURL }}" />
              } @else {
                <app-user-icon class="text-current"></app-user-icon>
              }</div
          ></label> -->
          <app-bars-icon
            class="inline-block h-8 w-8 text-current"
          ></app-bars-icon>
        </div>
      </summary>
      <div
        tabindex="0"
        class="card dropdown-content card-compact absolute left-0 z-[1] w-screen rounded-none bg-primary p-2 text-primary-content shadow"
      >
        <div class="card-body">
          <ul class="menu h-full w-full p-0 text-primary-content">
            @if (currentTenant) {
              <li class="mt-auto">
                <a class="text-xl normal-case" (click)="copyAccountNumber()">
                  <app-file-copy-icon class="h-5 w-5"></app-file-copy-icon>
                  Account #: {{ currentTenant.account_number }}
                </a>
              </li>
            }
            <li class="mt-auto">
              <a
                class="text-xl normal-case"
                [routerLink]="['/tenant/settings']"
              >
                <app-cog-icon
                  class="inline-block h-5 w-5 text-current"
                ></app-cog-icon>
                Company Settings
              </a>
            </li>
            @if (viewService.currentView === 'user') {
              <li>
                <a
                  class="text-xl normal-case"
                  [routerLink]="['/des-credits']"
                >
                  <app-dollar-icon
                    class="inline-block h-5 w-5 text-current"
                  ></app-dollar-icon>
                  DES Credits
                </a>
              </li>
            }
            <li class="mt-auto">
              <a class="text-xl normal-case" [routerLink]="['/user-settings']">
                <app-user-setting-icon
                  class="inline-block h-5 w-5 text-current"
                ></app-user-setting-icon>
                User Settings
              </a>
            </li>
            <li class="mt-auto">
              <a class="text-xl normal-case" (click)="signOut()">
                <app-arrow-right-to-bracket-icon
                  class="inline-block h-5 w-5 text-current"
                ></app-arrow-right-to-bracket-icon>
                Logout
              </a>
            </li>
          </ul>
        </div>
      </div>
    </details>
  </div>
</div>

<!-- Bottom Nav -->
<div class="btm-nav w-screen border-t border-base-300">
  @if (showAdmin) {
    <button
      [routerLink]="['/admin']"
      class="text-primary"
      [ngClass]="{
        'active text-secondary': currentMobileBottomNavTab === '/admin',
      }"
    >
      <app-user-setting-icon class="h-7 w-7"></app-user-setting-icon>
    </button>
  } @else {
    <button [routerLink]="['']" class="text-primary">
      <app-home-icon class="h-7 w-7"></app-home-icon>
    </button>
  }
  <button
    [routerLink]="['/licenses']"
    class="text-primary"
    [ngClass]="{
      'active text-secondary': currentMobileBottomNavTab === '/licenses',
    }"
  >
    <app-clipboard-icon class="h-7 w-7"></app-clipboard-icon>
  </button>

  <button
    [routerLink]="['/receipts']"
    class="text-primary"
    [ngClass]="{
      'active text-secondary': currentMobileBottomNavTab === '/receipts',
    }"
  >
    <app-file-invoice-icon class="h-7 w-7"></app-file-invoice-icon>
  </button>
  <button
    [routerLink]="['/tenant/users']"
    class="text-primary"
    [ngClass]="{
      'active text-secondary': currentMobileBottomNavTab === '/tenant/users',
    }"
  >
    <app-users-icon class="h-7 w-7"></app-users-icon>
  </button>
  <button
    [routerLink]="['/saved-payment-methods']"
    class="text-primary"
    [ngClass]="{
      'active text-secondary':
        currentMobileBottomNavTab === '/saved-payment-methods',
    }"
  >
    <app-credit-card-icon class="h-7 w-7"></app-credit-card-icon>
  </button>
</div>
